import { render, staticRenderFns } from "./MassTransitSettings.vue?vue&type=template&id=4d9b941c&scoped=true"
import script from "./MassTransitSettings.vue?vue&type=script&lang=ts"
export * from "./MassTransitSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9b941c",
  null
  
)

export default component.exports